<a pButton pRipple [href]="block.entry ? block.entry :  block.url" [target]="block.target ? block.target : '_self'"
   (click)="beforeOrAfterClick($event)"
   [class]="'font-bold no-underline block md:inline-block rounded-3xl ' + (blockClass ? (blockClass + ' ') : '') + theme.current.button + (block.class_overwrite ? (' ' + block.class_overwrite) : '' )">
    <app-icon *ngIf="block.icon && block.button_icon_alignment.value === 'left'" [icon]="block.icon.value"
              class="mr-2"></app-icon>
    {{ block.title }}
    <app-icon *ngIf="block.icon && block.button_icon_alignment.value === 'right'" [icon]="block.icon.value"
              class="ml-2"></app-icon>
</a>
